var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
    'btn-filled': _vm.theme === 'filled',
    'btn-outline': _vm.theme === 'outline',
    'btn-primary': _vm.type === 'primary',
    'btn-success': _vm.type === 'success',
    'btn-info': _vm.type === 'info',
    'btn-warning': _vm.type === 'warning',
    'btn-danger': _vm.type === 'danger',
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }